module.exports = "/_next/static/images/f260aa6a43eb9ee03de3e5ffe10b1003-savingsbanner-md-1-5x.jpg.webp";